import { BriefDeliverableTaskTypeEnum } from "@entities/brief/lib/constants";
import { FileText, Radio, ScrollText, Video } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export function getTaskIcon(
  taskType: BriefDeliverableTaskTypeEnum
): LucideIcon {
  switch (taskType) {
    case BriefDeliverableTaskTypeEnum.Brief:
      return FileText;
    case BriefDeliverableTaskTypeEnum.Script:
      return ScrollText;
    case BriefDeliverableTaskTypeEnum.Draft:
      return Video;
    case BriefDeliverableTaskTypeEnum.Live:
      return Radio;
    case BriefDeliverableTaskTypeEnum.Others:
      return FileText;
    default:
      return FileText;
  }
}
